import { lightBlue, grey } from '@mui/material/colors'
import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  palette: {
    primary: lightBlue,
    secondary: grey,
  },
})
